import { ButtonConfig } from "../../wrappers/lib/button/button.config";

export enum PageButtonTypes {
    prevStep = 1,
    prevDraft,
    cancel,
    submit,
    nextStep,
    delete,
}

export type BasePageButton = {
    type:      keyof typeof PageButtonTypes;
    label?:     string;
    disabled?: boolean;
    icon?: string;
    iconPos?: 'left' | 'right';
    config: keyof typeof ButtonConfig.baseTheme | ButtonConfig;
    routerLink?: (string | object)[];
    click?:    (event?: Event) => void | Promise<void>;
};
export type PageButton = BasePageButton;

export type PageButtons = PageButton[];
